function debounce(func, wait, immediate) {
    let timeout;

    return function executedFunction() {
        const context = this;
        const args = arguments;

        const later = function() {
            timeout = null;
            if(!immediate) func.apply(context, args);
        }

        const callNow = immediate && !setTimeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if(callNow) func.apply(context, args);
    }
}

const APP = {
	name: 'iBrush HTML Starter'
};

const media = {
    desktopLarge: 1750,
    desktop: 1400,
    desktopSm: 1280,
    tablet: 1024,
    mobile: 767,
}

class CssVars {
    constructor() {
        //elems
        this.elems = {};
        this.elems.$header = $('.js-sticky-header');
        this.elems.$smoothHeight = $('.js-smooth-height');

        this.set('--calc-height', 'auto');
        this.update();
        this.addListeners();
    }

    update() {
        const {$header, $smoothHeight} = this.elems;
        this.set('--header-height', $header.outerHeight());

        // smooth height
        $smoothHeight.each(function() {
            const height = $(this).children().outerHeight(true);
            if(this.style.getPropertyValue('--calc-height') !== height) {
                this.style.setProperty('--calc-height', height + 'px');
            }
        });
    }

    get(name) {
        const value = getComputedStyle(document.documentElement).getPropertyValue(name);
        return parseInt(value, 10);
    }

    set(name, value) {
        if($.isNumeric(value)) {
            document.documentElement.style.setProperty(name, value + 'px');
        } else {
            document.documentElement.style.setProperty(name, value);
        }
    }

    addListeners() {
        $(window).on('resize popstate', (e) => {
            this.update();
        });
    }
}

const cssVars = new CssVars();

class TabObserver extends IntersectionObserver {
    constructor(elem) {

        const marginTop = cssVars.get('--header-height') + 1;
        const rootMargin = `-${marginTop}px 0px 0px 0px`;
        const options = {
            rootMargin,
            threshold: 1,
        };

        const callback = function(entries, observer) {
            const {intersectionRect, rootBounds} = entries[0];
            const isSticky = intersectionRect.y === rootBounds.y;
            if(isSticky) {
                $('body').addClass('_tab-sticked');
                tabs.prototype.updateTracer(true);
            } else {
                $('body').removeClass('_tab-sticked');
                tabs.prototype.updateTracer(true);
            }
        };

        const observer = super(
            callback,
            options,
        );


        observer.observe(elem);
    }

}
const tabNav = $('.js-tab-scroll').get(0);
let tabObserver;

if(tabNav) {
    tabObserver = new TabObserver(tabNav);
}

$(window).on('resize', function(e) {
    if(tabNav) {
        tabObserver = new TabObserver(tabNav);
    }
});

$(() => {
    svg4everybody();
    sliders();
    video();
    stickyHeader();
    tabs();
    timer();

    setTimeout(() => {
        new Animation();
        $('.js-hover-start-anim').hover(
            function() {
                Animation.paused.play();
            },
            function() {
                Animation.paused.pause();
            }
        );
    }, 0);

    $('.js-menu-toggle').on('click', function() {
        $('body').toggleClass('_menu-open');
    });
});

class Animation {
    constructor() {
        gsap.config({
            nullTargetWarn: false
        })
        // plugins
        gsap.registerPlugin(ScrollTrigger);

        // state
        this.width = window.innerWidth;

        // this.listeners();
        // this.globalScroll();
        this.titleTop();
        this.title();
        this.circleText();
        this.glareTop();
        this.glare();
        this.runningLine();
        this.bigTextAppearance();
        this.parallax();
        this.mainTextAppearance();
        this.mainSlider();
        this.configTitle();

        $('body').removeClass('_loading');
    }

    // listeners() {
    //     ScrollTrigger.addEventListener('refreshInit', () => this.setBodyHeight());
    // }

    // setBodyHeight() {
    //     const height = this.elems.$scrollContainer.height();
    //     $('body').css('height', height);
    // }

    //
    // globalScroll() {
    //     const { $scrollContainer } = this.elems;
    //     if(!$scrollContainer.length) return;
    //
    //     gsap.to($scrollContainer.get(0), {
    //         y: () => -($scrollContainer.height() - $(communication).height()),
    //         ease: 'none',
    //         scrollTrigger: {
    //             trigger: 'body',
    //             start: 'top top',
    //             end: 'bottom bottom',
    //             scrub: .5,
    //             // scrub: true,
    //             invalidateOnRefresh: true,
    //         }
    //     });
    // }

    circleText() {
        const $circle = $('.js-anim-circle-text');
        if(!$circle.length) return;

        $circle.each(function() {
            gsap.to(this, {
                scrollTrigger: {
                    trigger: this,
                    toggleActions: 'play pause play pause',
                    scrub: .8,
                },
                rotation: 150,
                ease: 'power1',
            });
        });
    }

    titleTop() {
        const tl = gsap.timeline()
            .addLabel('label-1')
            .from('.js-anim-nav-link', {
                xPercent: -100,
                opacity: 0,
                stagger: .3,
                duration: .5,
                onComplete() {
                    $('.js-anim-config-link').removeClass('_non-active');
                }
            }, 'label-1');

        const $title = $('.js-anim-h1-top');
        if(!$title.length) return;

        tl.from($title.get(), {
                scrollTrigger: 'body',
                duration: .8,
                stagger: .2,
                yPercent: 100,
                opacity: 0,
                ease: 'power1.inOut',
            }, 'label-1');

        const $opacityTopElem = $('.js-anim-opacity-top');
        if(!$opacityTopElem.length) return;

        tl.from($opacityTopElem.get(), {
                opacity: 0,
                duration: .5,
        });
    }

    title() {
        const $title = $('.js-anim-h1');
        if(!$title.length) return;

        const $glare = $title.siblings('.js-anim-glare');

        gsap.from($title.get(), {
            scrollTrigger: {
                trigger: $glare.get(0),
                toggleActions: 'play none none reverse',
                start: '40% bottom',
            },
            yPercent: 100,
            opacity: 0,
            stagger: .2,
            duration: .8,
            ease: 'power1.inOut'
        });
    }

    glareTop() {
        const glare = $('.js-anim-glare-top').get(0);
        if(!glare) return;

        gsap.set(glare, {rotation: 25});
        gsap.to(glare, {
            scrollTrigger: {
                trigger: 'body',
                start: 'top top',
                endTrigger: glare,
                toggleActions: 'restart pause reverse pause',
                // scrub: true,
                scrub: 0.5,
            },
            // ease: 'expo',
            rotation: 90,
        });
    }

    glare() {
        const $glare = $('.js-anim-glare');
        if(!$glare.length) return;

        $glare.each(function() {
            gsap.to(this, {
                scrollTrigger: {
                    trigger: this,
                    toggleActions: 'restart pause reverse pause',
                    scrub: 0.5,
                },
                // ease: 'expo',
                rotation: 90,
            });

        })
    }

    runningLine() {
        $('.js-running-line').each(function() {
            const $line = $(this);
            const $unit = $line.find('.js-running-line-unit');
            const $container = $line.closest('.js-running-line-container');
            let unitWidth
            let fullUnitCount;

            setVariables();

            function setVariables() {
                $line.find('.js-running-line-unit').not(':first').remove();

                unitWidth = $unit.width();
                fullUnitCount = Math.floor($container.width() / $unit.width()) + 1;

                for (let i = 0; i < fullUnitCount * 2; i++) {
                    $line.append($unit.clone())
                }
            }

            if($line.data('paused') !== undefined) {
                Animation.paused = gsap.to($line[0], {
                    duration: 10,
                    repeat: -1,
                    x: -unitWidth * (fullUnitCount),
                    paused: true,
                    ease: 'power0',
                });
            } else {
                gsap.to($line[0], {
                    scrollTrigger: {
                        // markers: true,
                        trigger: $line[0],
                        // scroller: '.js-global-scroll',
                        toggleActions: "restart pause reverse pause",
                        // scrub: true,
                        scrub: 1.5,
                    },
                    ease: 'power0',
                    x: -unitWidth * (fullUnitCount) / 2.5,
                    onUpdate() {
                        debounce(setVariables, 500);
                    },
                });
            }
        });
    }

    bigTextAppearance() {
        const bigText = $('.js-big-label').get();
        if(!bigText) return;

        gsap.from(bigText, {
            scrollTrigger: {
                // markers: true,
                trigger: bigText,
                onLeaveBack({animation}) {
                    animation.timeScale(10);
                    animation.reverse();
                },
                onEnter({animation}) {
                    animation.timeScale(1);
                    animation.play();
                },
                start() {
                    return window.innerWidth > media.tablet ?
                        'center bottom' : 'bottom 80%';
                },
            },
            duration: 2,
            opacity: 0,
        });
    }

    parallax() {
        const parallaxImg = $('.js-parallax-main-img').get(0);
        if(!parallaxImg) return;

        gsap.fromTo(parallaxImg,
            {
                y() {
                    if(window.innerWidth > media.tablet) {
                        return 60
                    } else if(window.innerWidth > media.mobile) {
                        return 300
                    } else {
                        return 100
                    }
                }
            },
            {
                scrollTrigger: {
                    scrub: 0.8,
                    trigger: '.js-advantage-section',
                    start: "top 70%",
                },
                y() {
                    if(window.innerWidth > media.tablet) {
                        return -270;
                    } else if(window.innerWidth > media.mobile) {
                        return -100;
                    } else {
                        return -90;
                    }
                },
            }
        );

        gsap.fromTo('.js-parallax-img[data-order="1"]',
            {
                y() {
                    if(window.innerWidth > media.tablet) {
                        return 100
                    } else if(window.innerWidth > media.mobile) {
                        return 300
                    } else {
                        return 200
                    }
                }
            },
            {
            scrollTrigger: {
                scrub: 0.8,
                trigger: '.js-advantage-section',
                start: "top 70%",
            },
            y() {
                if(window.innerWidth > media.tablet) {
                    return -200;
                } else if(window.innerWidth > media.mobile) {
                    return -100;
                } else {
                    return -90;
                }
            },
        }
        );

        gsap.fromTo('.js-parallax-img[data-order="2"]',
            {
                y() {
                    if(window.innerWidth > media.tablet) {
                        return 100
                    } else if(window.innerWidth > media.mobile) {
                        return 300
                    } else {
                        return 300
                    }
                }
            },
            {
                scrollTrigger: {
                    scrub: 0.8,
                    trigger: '.js-advantage-section',
                    start: "top 70%",
                },
                y() {
                    if(window.innerWidth > media.tablet) {
                        return -150;
                    } else if(window.innerWidth > media.mobile) {
                        return -100;
                    } else {
                        return -90;
                    }
                },
            }
        );

        gsap.fromTo('.js-parallax-text',
            {
                y() {
                    if(window.innerWidth > media.tablet) {
                        return 100
                    } else if(window.innerWidth > media.mobile) {
                        return 100
                    } else {
                        return 50
                    }
                }
            },
            {
                scrollTrigger: {
                    // scrub: true,
                    scrub: 0.8,
                    trigger: '.js-advantage-section',
                },
                y() {
                    if(window.innerWidth > media.tablet) {
                        return -100;
                    } else if(window.innerWidth > media.mobile) {
                        return -50;
                    } else {
                        return -45;
                    }
                },
            }
        );

        // opacity
        gsap.from('.js-parallax-text', {
            scrollTrigger: {
                // markers: true,
                trigger: '.js-advantage-section',
                toggleActions: "play none none reset",
            },
            duration: 2,
            opacity: 0,
        })
    }

    mainTextAppearance() {
        const elem = $('.js-anim-coll-text').get(0);
        if(!elem) return

        gsap.from(elem,{
            scrollTrigger: {
                trigger: elem,
                toggleActions: "play none none reverse",
                start: 'top 85%',
            },
            opacity: 0,
            duration: 1,
        });
    }

    mainSlider() {
        const slider = $('.js-main-slider').get(0);
        if(!slider) return

        function start() {
            if(window.innerWidth > media.tablet) {
                return 'top 85%';
            }  else {
                return 'top 90%';
            }
        }

        gsap.from(slider,{
            scrollTrigger: {
                trigger: slider,
                toggleActions: "play pause restart reverse",
                start,
            },
            opacity: 0,
            duration: 1,
            ease: 'power2.inOut'
        });

        gsap.from('.js-adv-slider',{
            scrollTrigger: {
                trigger: '.js-main-slider',
                toggleActions: "play pause restart reverse",
                start,
            },
            duration: 1,
            opacity: 0,
            ease: 'power2.inOut'
        });

        gsap.from('.js-slider-prev, .js-slider-next, .js-dots',{
            scrollTrigger: {
                trigger: '.js-main-slider',
                toggleActions: "play pause restart reverse",
                start,
            },
            duration: 1,
            opacity: 0,
            ease: 'power2.inOut',
        });
    }

    configTitle() {
        const title = $('.js-config-title').get(0);
        if(!title) return;

        gsap.from(title, {
            scrollTrigger: {
                trigger: title,
                start: 'center bottom',
                toggleActions: "play none none reverse",
            },
            opacity: 0,
            duration: .5,
        });
    }

}



function sliders() {
    initMainPageSlider();
    initCollectionPageSlider();
}

function initMainPageSlider() {
    // main page slider
    const $container = $('.js-main-page-slider-container');
    const $mainSlider = $container.find('.js-main-slider');
    const $advSlider = $container.find('.js-adv-slider');
    const $dots = $container.find('.js-dots');
    const $prevArrow = $container.find('.js-slider-prev');
    const $nextArrow = $container.find('.js-slider-next');
    const $slideText = $container.find('.js-slide-text');
    const count = $mainSlider.children().length;
    const text = [
        'Первые мастер-спальни: ваша частная территория',
        'Архитектура: достоинство в&nbsp;каждой детали',
        'Больше естественного света в&nbsp;каждой квартире',
        'Общественные пространства: высота, свет, зонирование',
        'Благоустройство и&nbsp;безопасность: первые дворы без машин',
    ]
    let current;

    // $container.find('.js-slider-next').on('click', function() {
    //     $advSlider.slick('slickNext');
    //     $mainSlider.slick('slickNext');
    // });

    // $container.find('.js-slider-prev').on('click', function() {
    //     $advSlider.slick('slickPrev');
    //     $mainSlider.slick('slickPrev');
    // });



    $mainSlider.on('init', function(e, slick) {
        const dotsArr = Array(slick.slideCount).fill(1);

        const str = dotsArr.map((_, i) => {
            const isCurrent = i === slick.currentSlide;
            if(isCurrent) {
                current = i;
            }
            return `
                <button class="collection__dot js-dot ${isCurrent ? '_active' : ''}" data-slide="${i}"></button>
            `
        })
        $dots.html(str);
    });

    $mainSlider.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
        setActiveDot(nextSlide);
        changeText(nextSlide);
    });

    // $mainSlider.on('swipe', function(e, slick, direction) {
    //     if(direction === 'right') {
    //         $advSlider.slick('slickNext');
    //     } else {
    //         $advSlider.slick('slickNext');
    //     }
    // });

    $(document).on('click', '.js-dot', function() {
        const slide = $(this).data('slide');
        if(slide === current) return

        $mainSlider.slick('slickGoTo', slide);
        $advSlider.slick('slickGoTo', slide);

        setActiveDot(slide);
        changeText(slide);
    });

    $mainSlider.slick({
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        asNavFor: $advSlider,
    });

    $advSlider.slick({
        arrows: false,
        asNavFor: $mainSlider,
    });

    function setActiveDot(num) {
        if(num === current) return

        $dots
            .children()
            .get(current)
            .classList.remove('_active');

        $dots.children().get(num).classList.add('_active');
        current = num;
    }

    function changeText(index) {
        $slideText.html(text[index]);
    }
}

let collectionSlider;

function initCollectionPageSlider() {
    const $container = $('.js-spirit-slider-container');
    const $slider = $container.find('.js-slider');
    const $prevArrow = $container.find('.js-slider-prev');
    const $nextArrow = $container.find('.js-slider-next');

    collectionSlider = $slider.slick({
        variableWidth: true,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
    });

    collectionSlider.on('beforeChange', function(e, slick, current, nextSlide) {
        tabs.prototype.changeTab(Math.floor(nextSlide / 2));
    })
}



function stickyHeader() {
    const $stickyHeader = $('.js-sticky-header');
    const tabNav = $('.js-tab-scroll').get(0);


    // condition hell for padding
    let onePaddingReady;

    $stickyHeader.on('transitionend', function(e) {
        if(
            $(e.target).is(this) &&
            (e.originalEvent.propertyName === 'padding-bottom') ||
            (e.originalEvent.propertyName === 'padding-top')
        ) {
            if(!onePaddingReady) {
                onePaddingReady = true;
                return;
            }
            // action
            cssVars.set('--header-height', $stickyHeader.outerHeight());

            if(tabNav && !tabObserver) {
                tabObserver = new TabObserver(tabNav);
            } else if(tabObserver) {
                tabObserver.disconnect();
                tabObserver = new TabObserver(tabNav);
            }
        }
    });

    if($('.js-configurator').length) {
        $('body').addClass('_header-sticked');
        return
    }

    let sticked

    checkSticky();
    $(window).on('scroll', checkSticky);

    function checkSticky() {
        if(window.scrollY > 30 && !sticked) {
           $('body').addClass('_header-sticked');
           cssVars.update();
            sticked = true;
        } else if(window.scrollY <= 30){
           $('body').removeClass('_header-sticked')
            sticked = false;
            cssVars.update();
        }
    }
}

function video() {
    let isFirstLoad = true;

    $('.js-play').on('click', function() {
        const $container = $(this).closest('.js-video-container');
        $container.find('.js-video')
            .attr('controls', '')
            .get(0)
            .play();
        $container.addClass('_playing');
    });

    // $('.js-video').on('loadedmetadata', () => {
    //     if(!isFirstLoad) return

    //     animations();
    //     isFirstLoad = false;
    // });

    $('.js-video').on('ended', function() {
        $(this)
            .removeAttr('controls')
            .get(0)
            .load()
        $(this)
            .closest('.js-video-container')
            .removeClass('_playing')
    });
}

function tabs() {
    const $container = $('.js-tabs-container');
    if(!$container.length) return

    let $activeNav = $container.find('.js-tab-nav._active');
    let $activeTab = $container.find('.js-tab._active');
    const $tracer = $container.find('.js-tab-tracer');
    const $navScroll = $container.find('.js-tab-scroll');
    const $tabList = $container.find('.js-tab-list');


    $('.js-tab-nav').on('click', function() {
        const $nav = $(this);
        const id = $nav.data('id');
        changeTab(id, false, $nav);
    });

    setTimeout(() => {
        $tracer.width($activeNav.width());
    }, 0);

    // прокрутка
    $('.js-tab-scroll').on('wheel', function(e) {
        if(this.scrollWidth <= $(this).width()) return

        const delta = e.originalEvent.wheelDelta;
        this.scrollLeft -= delta;
        e.preventDefault();
    });

    // переход в конфигуратор
    $('.js-config-link').on('click', function(e) {
        e.preventDefault();
        const param = $activeNav.data('param');
        const url = new URL(`${this.href}?base=${param}`);
        window.location.href = url;
    });

    // tracer position
    function updateTracer(immediately) {
        gsap.to($tracer.get(0), {
            duration() {
                return immediately ? 0 : .3;
            },
            width: $activeNav.width(),
            x: $activeNav.position().left + $navScroll.scrollLeft(),
            ease: 'circ.inOut',
        });

        gsap.to($navScroll.get(0), {
            duration() {
                return immediately ? 0 : .3;
            },
            scrollLeft: $activeNav.position().left + $navScroll.scrollLeft(),
            ease: 'power2',
        });
    }

    tabs.prototype.updateTracer = updateTracer;

    $(window).on('resize', debounce(updateTracer, 300));

    function changeTab(id, fromSlider, $elem) {
        let $navItem;

        if($elem) {
            $navItem = $elem;
        } else {
            $navItem = $container.find(`.js-tab-nav[data-id="${id}"]`)
        }

        if($navItem.is($activeNav)) return;

        const $newTab = $container.find(`.js-tab[data-id=${id}]`);

        // change slider below
        if(!fromSlider) {
            collectionSlider.slick('slickGoTo', +id * 2)
        }

        gsap.timeline()
            .to($activeTab.get(0), {
                opacity: 0,
                duration: .2,
                onComplete() {
                    $activeTab.removeClass('_active');
                    $newTab.addClass('_active');
                    $activeTab = $newTab;
                }
            })
            .fromTo($newTab.get(0), {opacity: 0},{
                opacity: 1,
                duration: .2,
            });

        $activeNav.removeClass('_active');
        $navItem.addClass('_active');
        $activeNav = $navItem;

        updateTracer();

        // stop all youtube videos
        playerArr.forEach(player => player.stopVideo());
    }

    tabs.prototype.changeTab = changeTab;

    // fix height
    if($tabList.length) {
        setTimeout(calcMaxHeight, 0)
        $(window).on('resize', debounce(calcMaxHeight, 300));
    }

    function calcMaxHeight() {
        let maxHeight = 0;

        $container.find('.js-tab').each(function() {
            console.log(this.offsetHeight)
            const height = this.offsetHeight;
            if(height > maxHeight) maxHeight = height;
        });

        $tabList.css('min-height', maxHeight + 'px');
    }
}

function smoothHeight() {
    document.documentElement.style.setProperty('--calc-height', 'auto');


    $(window).on('resize', setVariable);
    $(window).on('load', setVariable);
}

function setVariable() {
    $('.js-smooth-height').each(function() {
        const height = $(this).children().outerHeight(true) + 'px';
        if(this.style.getPropertyValue('--calc-height') !== height) {
            this.style.setProperty('--calc-height', height);
        }
    });
}


// paths
class Path {
    constructor(base) {
        this.base = base;
    }

    bike(file) {
        return `${this.base}bike/${file}`;
    }

    location(file) {
        return `${this.base}location/${file}`;
    }

    communication(file) {
        return `${this.base}communication/${file}`;
    }

    window(file) {
        return `${this.base}window/${file}`;
    }

    material(file) {
        return `${this.base}material/${file}`;
    }
}

const path = new Path('/assets/img/configurator/');
const pathShare = new Path('/shares/');

// db
const db = {
    images: [
        {
            id: 1,
            url: path.bike('empty.png'),
        },
        {
            id: 2,
            url: path.bike('silver.png'),
            share: pathShare.bike('silver.jpg'),
            vk: 'photo-202828765_457239019',
        },
        {
            id: 3,
            url: path.bike('silver_relief-1.png'),
            share: pathShare.bike('silver_relief-1.jpg'),
            vk: 'photo-202828765_457239020',
        },
        {
            id: 4,
            url: path.bike('silver_relief-2.png'),
            share: pathShare.bike('silver_relief-2.jpg'),
            vk: 'photo-202828765_457239021',
        },
        {
            id: 5,
            url: path.bike('gold.png'),
            share: pathShare.bike('gold.jpg'),
            vk: 'photo-202828765_457239022',
        },
        {
            id: 6,
            url: path.bike('gold_relief-1.png'),
            share: pathShare.bike('gold_relief-1.jpg'),
            vk: 'photo-202828765_457239017',
        },
        {
            id: 7,
            url: path.bike('gold_relief-2.png'),
            share: pathShare.bike('gold_relief-2.jpg'),
            vk: 'photo-202828765_457239018',
        },
        {
            id: 8,
            url: path.location('cell_black-silver.png'),
            share: pathShare.location('cell_black-silver.jpg'),
            vk: 'photo-202828765_457239024',
        },
        {
            id: 9,
            url: path.location('trapeze_black-silver.png'),
            share: pathShare.location('trapeze_black-silver.jpg'),
            vk: 'photo-202828765_457239036',
        },
        {
            id: 10,
            url: path.location('diagonal_black-silver.png'),
            share: pathShare.location('diagonal_black-silver.jpg'),
            vk: 'photo-202828765_457239030',
        },
        {
            id: 11,
            url: path.location('cell_gold.png'),
            share: pathShare.location('cell_gold.jpg'),
            vk: 'photo-202828765_457239025',
        },
        {
            id: 12,
            url: path.location('trapeze_gold.png'),
            share: pathShare.location('trapeze_gold.jpg'),
            vk: 'photo-202828765_457239037',
        },
        {
            id: 13,
            url: path.location('diagonal_gold.png'),
            share: pathShare.location('diagonal_gold.jpg'),
            vk: 'photo-202828765_457239031',
        },
        {
            id: 14,
            url: path.location('cell_gold_fox.png'),
            share: pathShare.location('cell_gold_fox.jpg'),
            vk: 'photo-202828765_457239027',
        },
        {
            id: 15,
            url: path.location('diagonal_gold_fox.png'),
            share: pathShare.location('diagonal_gold_fox.jpg'),
            vk: 'photo-202828765_457239039',
        },
        {
            id: 16,
            url: path.location('trapeze_gold_fox.png'),
            share: pathShare.location('trapeze_gold_fox.jpg'),
            vk: 'photo-202828765_457239033',
        },
       {
            id: 17,
            url: path.location('cell_silver_fox.png'),
            share: pathShare.location('cell_silver_fox.jpg'),
            vk: 'photo-202828765_457239029',
        },
        {
            id: 18,
            url: path.location('diagonal_silver_fox.png'),
            share: pathShare.location('diagonal_silver_fox.jpg'),
            vk: 'photo-202828765_457239035',
        },
        {
            id: 19,
            url: path.location('trapeze_silver_fox.png'),
            share: pathShare.location('trapeze_silver_fox.jpg'),
            vk: 'photo-202828765_457239023',
        },
        {
            id: 20,
            url: path.location('cell_gold_bee.png'),
            share: pathShare.location('cell_gold_bee.jpg'),
            vk: 'photo-202828765_457239026',
        },
        {
            id: 21,
            url: path.location('diagonal_gold_bee.png'),
            share: pathShare.location('diagonal_gold_bee.jpg'),
            vk: 'photo-202828765_457239032',
        },
        {
            id: 22,
            url: path.location('trapeze_gold_bee.png'),
            share: pathShare.location('trapeze_gold_bee.jpg'),
            vk: 'photo-202828765_457239038',
        },
       {
            id: 23,
            url: path.location('cell_silver_bee.png'),
            share: pathShare.location('cell_silver_bee.jpg'),
            vk: 'photo-202828765_457239028',
        },
        {
            id: 24,
            url: path.location('diagonal_silver_bee.png'),
            share: pathShare.location('diagonal_silver_bee.jpg'),
            vk: 'photo-202828765_457239034',
        },
        {
            id: 25,
            url: path.location('trapeze_silver_bee.png'),
            share: pathShare.location('trapeze_silver_bee.jpg'),
            vk: 'photo-202828765_457239040',
        },
        {
            id: 26,
            url: path.communication('gold.png'),
        },
        {
            id: 27,
            url: path.communication('silver.png'),
        },
        {
            id: 28,
            url: path.communication('gold_white-rhodium.png'),
        },
        {
            id: 29,
            url: path.communication('gold_black-rhodium.png'),
        },
        {
            id: 30,
            url: path.communication('silver_golding.png'),
        },
        {
            id: 31,
            url: path.communication('silver_blacking.png'),
        },
        {
            id: 32,
            url: path.communication('gold_white-rhodium_black-diamond.png'),
            share: pathShare.communication('gold_white-rhodium_black-diamond.jpg'),
            vk: 'photo-202828765_457239042',
        },
        {
            id: 33,
            url: path.communication('gold_white-rhodium_diamond.png'),
            share: pathShare.communication('gold_white-rhodium_diamond.jpg'),
            vk: 'photo-202828765_457239043',
        },
        {
            id: 34,
            url: path.communication('gold_black-rhodium_black-diamond.png'),
            share: pathShare.communication('gold_black-rhodium_black-diamond.jpg'),
            vk: 'photo-202828765_457239051',
        },
        {
            id: 35,
            url: path.communication('gold_black-rhodium_diamond.png'),
            share: pathShare.communication('gold_black-rhodium_diamond.jpg'),
            vk: 'photo-202828765_457239052',
        },
        {
            id: 36,
            url: path.communication('gold_black-diamond.png'),
            share: pathShare.communication('gold_black-diamond.jpg'),
            vk: 'photo-202828765_457239050',
        },
        {
            id: 37,
            url: path.communication('gold_diamond.png'),
            share: pathShare.communication('gold_diamond.jpg'),
            vk: 'photo-202828765_457239041',
        },
        {
            id: 38,
            url: path.communication('silver_golding_black-diamond.png'),
            share: pathShare.communication('silver_golding_black-diamond.png'),
            vk: 'photo-202828765_457239048',
        },
        {
            id: 39,
            url: path.communication('silver_blacking_black-diamond.png'),
            share: pathShare.communication('silver_blacking_black-diamond.png'),
            vk: 'photo-202828765_457239045',
        },
        {
            id: 40,
            url: path.communication('silver_golding_diamond.png'),
            share: pathShare.communication('silver_golding_diamond.jpg'),
            vk: 'photo-202828765_457239049',
        },
        {
            id: 41,
            url: path.communication('silver_blacking_diamond.png'),
            share: pathShare.communication('silver_blacking_diamond.jpg'),
            vk: 'photo-202828765_457239046',
        },
        {
            id: 42,
            url: path.communication('silver_black-diamond.png'),
            share: pathShare.communication('silver_black-diamond.jpg'),
            vk: 'photo-202828765_457239044',
        },
        {
            id: 43,
            url: path.communication('silver_diamond.png'),
            share: pathShare.communication('silver_diamond.jpg'),
            vk: 'photo-202828765_457239047',
        },
        {
            id: 44,
            url: path.window('white-gold_blue-topaz_center-blue-nanocrystal.png'),
            share: pathShare.window('white-gold_blue-topaz_center-blue-nanocrystal.jpg'),
            vk: 'photo-202828765_457239062',
        },
        {
            id: 45,
            url: path.window('white-gold_blue-topaz_facetted-blue-nanocrystal.png'),
            share: pathShare.window('white-gold_blue-topaz_facetted-blue-nanocrystal.jpg'),
            vk: 'photo-202828765_457239063',
        },
        {
            id: 46,
            url: path.window('white-gold_colorless-topaz_facetted-rhinestone.png'),
            share: pathShare.window('white-gold_colorless-topaz_facetted-rhinestone.jpg'),
            vk: 'photo-202828765_457239064',
        },
        {
            id: 47,
            url: path.window('white-gold_colorless-topaz_rhinestone.png'),
            share: pathShare.window('white-gold_colorless-topaz_rhinestone.jpg'),
            vk: 'photo-202828765_457239053',
        },
        {
            id: 48,
            url: path.window('white-gold_facetted-pink-nanocrystal_pink-sapphire.png'),
            share: pathShare.window('white-gold_facetted-pink-nanocrystal_pink-sapphire.jpg'),
            vk: 'photo-202828765_457239054',
        },
        {
            id: 49,
            url: path.window('white-gold_pink-nanocrystal_pink-sapphire.png'),
            share: pathShare.window('white-gold_pink-nanocrystal_pink-sapphire.jpg'),
            vk: 'photo-202828765_457239055',
        },
        {
            id: 50,
            url: path.window('yellow-gold_blue-topaz_center-blue-nanocrystal.png'),
            share: pathShare.window('yellow-gold_blue-topaz_center-blue-nanocrystal.jpg'),
            vk: 'photo-202828765_457239056',
        },
        {
            id: 51,
            url: path.window('yellow-gold_blue-topaz_center-facetted-blue-nanocrystal.png'),
            share: pathShare.window('yellow-gold_blue-topaz_center-facetted-blue-nanocrystal.jpg'),
            vk: 'photo-202828765_457239057',
        },
        {
            id: 52,
            url: path.window('yellow-gold_colorless-topaz_center-facetted-thinestone.png'),
            share: pathShare.window('yellow-gold_colorless-topaz_center-facetted-thinestone.jpg'),
            vk: 'photo-202828765_457239058',
        },
        {
            id: 53,
            url: path.window('yellow-gold_colorless-topaz_center-rhinestone.png'),
            share: pathShare.window('yellow-gold_colorless-topaz_center-rhinestone.jpg'),
            vk: 'photo-202828765_457239059',
        },
        {
            id: 54,
            url: path.window('yellow-gold_facetted-smoky-quartz.png'),
            share: pathShare.window('yellow-gold_facetted-smoky-quartz.jpg'),
            vk: 'photo-202828765_457239060',
        },
        {
            id: 55,
            url: path.window('yellow-gold_smoky-quartz.png'),
            share: pathShare.window('yellow-gold_smoky-quartz.jpg'),
            vk: 'photo-202828765_457239061',
        },
       {
            id: 56,
            url: path.location('cell.png'),
        },
        {
            id: 57,
            url: path.location('trapeze.png'),
        },
        {
            id: 58,
            url: path.location('diagonal.png'),
        },
    ],
    bike: {
        title: 'Велосипедные',
        desc: 'Кольцо посвящено первым отдельным пространствам для хранения велосипедов в&nbsp;домах LEGENDA',
        empty: path.bike('empty.png'),
        steps: [
            {
                title: 'Выберите материал',
                items: [
                    {
                        name: 'Желтое золото',
                        thumbnail: path.material('gold-yellow.jpg'),
                        imgId: 5,
                    },
                    {
                        name: 'Черненое серебро',
                        thumbnail: path.material('silver-black.jpg'),
                        imgId: 2,
                    },
                ]
            },
            {
                title: 'Выберите рельеф',
                items: [
                    {
                        name: 'Рельеф 1',
                        thumbnail: path.material('relief1.jpg'),
                        imgIdMap: {
                            5: 6,
                            2: 3,
                        }
                    },
                    {
                        name: 'Рельеф 2',
                        thumbnail: path.material('relief2.jpg'),
                        imgIdMap: {
                            5: 7,
                            2: 4,
                        }
                    },
                    {
                        name: 'Без рельефа',
                        thumbnail: path.material('relief-none.jpg'),
                        imgIdMap: {
                            5: 5,
                            2: 2,
                        }
                    },
                ]
            },
        ],
    },
    location: {
        title: 'Локация',
        desc: 'Кольцо вдохновлено домом в&nbsp;стиле ар-деко, открывшим новый &laquo;нишевый&raquo; адрес на&nbsp;карте города&nbsp;&mdash; &laquo;Институтский, 16&raquo;.',
        empty: path.location('empty.png'),
        steps: [
            {
                title: 'Выберите паттерн',
                items: [
                    {
                        name: 'Клетка',
                        thumbnail: path.material('cell.jpg'),
                        imgId: 56,
                    },
                    {
                        name: 'Трапеция',
                        thumbnail: path.material('trapeze.jpg'),
                        imgId: 57,
                    },
                    {
                        name: 'Диагональ',
                        thumbnail: path.material('diagonal.jpg'),
                        imgId: 58,
                    },
                ]
            },
            {
                title: 'Выберите материал',
                items: [
                    {
                        name: 'Золото',
                        thumbnail: path.material('gold-with-silver.jpg'),
                        imgIdMap: {
                            56: 11,
                            57: 12,
                            58: 13,
                        }
                    },
                    {
                        name: 'Черненое серебро',
                        thumbnail: path.material('silver-with-gold.jpg'),
                        imgIdMap: {
                            56: 8,
                            57: 9,
                            58: 10,
                        }
                    },
                ]
            },
            {
                title: 'Выберите графический элемент',
                longTitle: true,
                items: [
                    {
                        name: 'Лиса',
                        thumbnail: path.material('fox.jpg'),
                        imgIdMap: {
                            8: 17,
                            9: 19,
                            10: 18,
                            11: 14,
                            12: 16,
                            13: 15,
                        }
                    },
                    {
                        name: 'Пчела',
                        thumbnail: path.material('bee.jpg'),
                        imgIdMap: {
                            8: 23,
                            9: 25,
                            10: 24,
                            11: 20,
                            12: 22,
                            13: 21,
                        }
                    },
                    {
                        name: 'Без графического элемента',
                        thumbnail: path.material('without-graph-elem.jpg'),
                        imgIdMap: {
                            8: 8,
                            9: 9,
                            10: 10,
                            11: 11,
                            12: 12,
                            13: 13,
                        }
                    },
                ]
            },
        ],
    },
    communication: {
        title: 'Коммуникации',
        desc: 'Серьги вдохновлены современными технологическими решениями, не&nbsp;имеющими аналогов на&nbsp;рынке.',
        empty: path.communication('empty.png'),
        steps: [
            {
                title: 'Выберите материал',
                items: [
                    {
                        name: 'Золото',
                        thumbnail: path.material('gold-yellow.jpg'),
                        imgId: 26,
                    },
                    {
                        name: 'Серебро',
                        thumbnail: path.material('silver.jpg'),
                        imgId: 27,
                    },
                ]
            },
            {
                title: 'Выберите внутреннее покрытие',
                variable: true,
                longTitle: true,
                items: [
                    {
                        prevImgId: 26,
                        name: 'Белый родий',
                        thumbnail: path.material('white-rhodium.jpg'),
                        imgId: 28,
                    },
                    {
                        prevImgId: 26,
                        name: 'Черный родий',
                        thumbnail: path.material('black-rhodium.jpg'),
                        imgId: 29,
                    },
                    {
                        prevImgId: 26,
                        name: 'Без покрытия',
                        thumbnail: path.material('without-cover.jpg'),
                        imgId: 26,
                    },
                    {
                        prevImgId: 27,
                        name: 'Золочение',
                        thumbnail: path.material('golding.jpg'),
                        imgId: 30,
                    },
                    {
                        prevImgId: 27,
                        name: 'Чернение',
                        thumbnail: path.material('blacking.jpg'),
                        imgId: 31,
                    },
                    {
                        prevImgId: 27,
                        name: 'Без покрытия',
                        thumbnail: path.material('without-cover.jpg'),
                        imgId: 27,
                    },

                ]
            },
            {
                title: 'Выберите инкрустацию',
                require: true,
                items: [
                    {
                        name: 'Белые бриллианты',
                        thumbnail: path.material('diamond.jpg'),
                        imgIdMap: {
                            26: 37,
                            27: 43,
                            28: 33,
                            29: 35,
                            30: 40,
                            31: 41,
                        }
                    },
                    {
                        name: 'Черные бриллианиты',
                        thumbnail: path.material('black-diamond.jpg'),
                        imgIdMap: {
                            26: 36,
                            27: 42,
                            28: 32,
                            29: 34,
                            30: 38,
                            31: 39,
                        }
                    },
                ]
            },
        ],
    },
    window: {
        title: 'Круизные окна',
        desc: 'Подвеска посвящена одному из&nbsp;самых красивых интерьерных решений, представленных в&nbsp;проекте &laquo;Московский, 65&raquo;',
        empty: path.window('empty.png'),
        steps: [
            {
                title: 'Выберите материал',
                items: [
                    {
                        name: 'Желтое золото',
                        thumbnail: path.material('gold-yellow.jpg'),
                        imgId: 53,
                    },
                    {
                        name: 'Белое золото',
                        thumbnail: path.material('white-gold.jpg'),
                        imgId: 47,
                    },
                ]
            },
            {
                title: 'Выберите инкрустацию',
                variable: true,
                items: [
                    {
                        prevImgId: 53,
                        name: 'Голубой топаз',
                        thumbnail: path.material('blue-topaz.jpg'),
                        imgId: 50,
                    },
                    {
                        prevImgId: 53,
                        name: 'Раухтопаз',
                        thumbnail: path.material('smoky-quartz.jpg'),
                        imgId: 55,
                    },
                    {
                        prevImgId: 53,
                        name: 'Прозрачный топаз',
                        thumbnail: path.material('colorless-topaz.jpg'),
                        imgId: 53,
                    },
                    {
                        prevImgId: 47,
                        name: 'Голубой топаз',
                        thumbnail: path.material('blue-topaz.jpg'),
                        imgId: 44,
                    },
                    {
                        prevImgId: 47,
                        name: 'Розовый нанокристалл',
                        thumbnail: path.material('pink-nanocrystal.jpg'),
                        imgId: 49,
                    },
                    {
                        prevImgId: 47,
                        name: 'Прозрачный топаз',
                        thumbnail: path.material('colorless-topaz.jpg'),
                        imgId: 47,
                    },
                ]
            },
            {
                title: 'Выберите огранку',
                items: [
                    {
                        name: 'С огранкой',
                        thumbnail: path.material('faceting.jpg'),
                        imgIdMap: {
                            50: 51,
                            55: 54,
                            53: 52,
                            44: 45,
                            49: 48,
                            47: 46,
                        }
                    },
                    {
                        name: 'Без огранки',
                        thumbnail: path.material('without-faceting.jpg'),
                        imgIdMap: {
                            50: 50,
                            55: 55,
                            53: 53,
                            44: 44,
                            49: 49,
                            47: 47,
                        }
                    },
                ]
            },
        ],
    },
}

class Templates {
    createListItem({ imgId, imgIdMap, name, thumbnail }) {
        const {selectedIdArr, currentStep} = this.state;
        let id

        if(imgId) {
            id = imgId;
        } else if(imgIdMap) {
            const prevId = selectedIdArr[currentStep-1];
            id = imgIdMap[prevId];
        }

        return `
            <li class="configurator__item">
                <button class="configurator__item-btn js-material-btn"  data-img-id="${id}" type="button">
                    <img src="${thumbnail}" class="configurator__item-img js-thumbnail">
                    <p class="configurator__item-text js-text">${name}</p>
                    <span class="configurator__item-label js-choose-btn">Выбрать</span>
                </button>
            </li>
        `
    }

    createSocialItem(id, mod, svg) {
        return `
        <li class="configurator__social-item">
            <a href="#" class="configurator__social-link ${mod}" data-id="${id}">
                <svg class="configurator__social-icon"><use xlink:href="${svg}"></use></svg>
                <span class="configurator__social-text">Поделиться</span>
            </a>
        </li>
        `
    }
}

class Share {
    saveResult(data){
        $.post('/save.php',data);
    }

    checkState(){
        if(this.auth){
            this.buttonText.text('Поделиться');
        } else {
            this.buttonText.text('Авторизоваться');
        }
    }

    addHandler(){
        let _this = this;
        this.button.off().on('click', function(e){
            e.preventDefault()
            if(_this.auth){
                _this.share()
            } else{
                _this.login()
            }
        })
    }
}

class FBShare extends Share {
    constructor(imgUrl, button, buttonText){
        super();
        let self = this;
        this.APP_ID = 256104396076923;
        this.MESSAGE = "Сообщение \n \n #tag";
        this.REDIRECT_URL = window.location.href.split(['#'])[0];
        this.img = imgUrl;
        this.button = button;
        this.buttonText = buttonText;
        this.auth = false;
        this.user = {};
        window.fbAsyncInit = function () {
            self.init();
        };
        if(FB !== undefined){
            self.init();
        }
        this.checkState()
        this.addHandler()
    }

    init(){
        FB.init({
            appId            : this.APP_ID,
            autoLogAppEvents : true,
            xfbml            : true,
            version          : 'v9.0'
        });
    }


    login(){
        let _this = this;
        FB.login(function(response) {
            console.log(response);
            if (response.authResponse.userID) {
                _this.auth = true
                _this.user.id = response.authResponse.userID
                _this.checkState()
            }
        }, {scope: 'email'});
    }

    share(){
        let _this = this;
        FB.ui({
            method: 'share',
            display: 'popup',
            hashtag: '#legends',
            quote: 'Тест',
            href: _this.REDIRECT_URL +'&img='+_this.img
        }, function(response){
            _this.getUserData();
        });
    }

    getUserData(){
        let _this = this;
        FB.api(
            '/me',
            'GET',
            {"fields":"id,name,email"},
            function(response) {
                _this.saveResult({type:'fb',link: response.id, name:response.name, email:response.email})
                console.log(response)
            }
        );

    }
}

class VKShare extends Share {
    constructor(img, button, buttonText, user){
        super();
        this.APP_ID = 7749503;
        this.MESSAGE = "Сообщение \n \n #legends";
        this.REDIRECT_URL = window.location.href.split(['#'])[0];
        this.img = img;
        this.button = button;
        this.buttonText = buttonText;
        this.auth = !!user.id;

        this.user = user;
        VK.init({
            apiId: this.APP_ID
        });
        this.checkState()
        this.addHandler()
    }

    login(){
        window.location.href='https://oauth.vk.com/authorize?client_id=' + this.APP_ID + '&display=page&redirect_uri=' + this.REDIRECT_URL + '&scope=wall,email,photos&response_type=token&v=5.126&state=' + JSON.stringify(window.state);
    }

    share(){
        let _this = this;
        VK.Api.call('wall.post', {owner_id: _this.user.id, message: _this.MESSAGE, attachments: _this.img}, function(r) {
            _this.getUserInfo();
        });
    }

    getUserInfo(){
        let _this = this;
        VK.Api.call('users.get', {'user_ids':_this.user.id, 'v':'5.126'}, function(r) {
            if(r.response){
                _this.user.name = r.response[0].first_name;
                _this.user.last_name = r.response[0].last_name;
                if(r.response[0].contacts !== undefined && r.response[0].contacts.mobile_phone !== undefined){
                    _this.user.phone = r.response[0].contacts.mobile_phone;
                }
                _this.saveResult({type:'vk',link: 'https://vk.com/id'+_this.user.id, name:_this.user.name+' '+ _this.user.last_name, email:_this.user.email, phone: _this.user.phone})
            }
        });
    }
}

class Configurator extends Templates {
    constructor($root) {
        super();

        this.$root = $root;
        const baseParam = new URL(window.location).searchParams.get('base');
        this.db = baseParam ? db[baseParam] : db.bike;
        this.state = {
            currentStep: 0,
            selectedIdArr: [],
        };
        this.user = {}
        this.elems = {};
        this.findElems();
        this.render();
        this.addListeners();
        this.parseHash()
    }

    findElems() {
        this.elems.$title = this.$root.find('.js-title');
        this.elems.$desc = this.$root.find('.js-desc');
        this.elems.$stepTitle = this.$root.find('.js-step-title');
        this.elems.$stepCurrent = this.$root.find('.js-step-current');
        this.elems.$stepTotal = this.$root.find('.js-step-total');
        this.elems.$list = this.$root.find('.js-material-list');
        this.elems.$mainImg = this.$root.find('.js-main-img');
        this.elems.$nextBtn = this.$root.find('.js-config-next');
        this.elems.$socialList = this.$root.find('.js-social-list');
    }

    render() {
        const {db} = this;
        const {$title, $desc, $stepTotal, $mainImg} = this.elems;
        $title.text(db.title);
        $desc.html(db.desc);
        $stepTotal.text(db.steps.length + 1);
        $mainImg.attr('src', db.empty);

        this.renderList();
        this.update();
    }

    renderResultPage() {
        const {$stepTitle, $stepCurrent, $list, $socialList, $nextBtn} = this.elems;
        const {currentStep, selectedIdArr} = this.state;
        const id = selectedIdArr[currentStep];

        $stepTitle.html('ПОДЕЛИТЕСЬ&nbsp;&mdash; И&nbsp;УЧАСТВУЙТЕ В&nbsp;РОЗЫГРЫШЕ УКРАШЕНИЯ');
        $stepCurrent.text(currentStep+1);
        $list.addClass('_hidden');
        $socialList.removeClass('_hidden');
        $nextBtn.addClass('_hidden');

        $socialList.html(
            this.createSocialItem(id, '_vk', '#vk') +
            this.createSocialItem(id, '_fb', '#fb')
        );

        let imgUrl = this.getShareImgUrlById(selectedIdArr[currentStep-1]);
        let vkId = this.getVkIDById(selectedIdArr[currentStep-1]);

        const fb = new FBShare(imgUrl, $('.configurator__social-link._fb'), $('.configurator__social-link._fb .configurator__social-text'));
        const vk = new VKShare(vkId, $('.configurator__social-link._vk'), $('.configurator__social-link._vk .configurator__social-text'), this.user);
    }

    renderList() {
        const {currentStep, selectedIdArr} = this.state;
        const {$list} = this.elems;

        const currentStepData = this.db.steps[currentStep];
        const prevImgId = selectedIdArr[currentStep-1];

        const listItems = currentStepData.variable ?
            currentStepData.items.filter(item => item.prevImgId === prevImgId) :
            currentStepData.items;

        $list.html('');
        listItems.forEach(item => {
            $list.append(this.createListItem(item));
        });
    }

    update() {
        const {currentStep, selectedIdArr} = this.state;
        const {$stepCurrent, $stepTitle, $nextBtn} = this.elems;
        const currentItem = this.db.steps[currentStep];

        $stepCurrent.text(currentStep+1);
        $stepTitle.text(currentItem.title);
        if(currentItem.longTitle) {
            $stepTitle.addClass('_long');
        } else {
            $stepTitle.removeClass('_long');
        }

        this.renderList();

        if(selectedIdArr[currentStep]) {
            this.setActive(selectedIdArr[currentStep]);
        } else {
            $nextBtn.addClass('_hidden');
        }
    }

    addListeners() {
        const {$nextBtn} = this.elems;
        $(document).on('click', '.js-material-btn', (e) => {
            const {currentStep, selectedIdArr} = this.state;
            const id = +e.currentTarget.dataset.imgId;

            if(selectedIdArr[currentStep] === id) {
                return
            } else {
                this.setActive(id);
            }
        });

        $(document).on('click', '.js-config-next', () => {
            const {currentStep, selectedIdArr} = this.state;
            if(!selectedIdArr[currentStep]) {
                this.state.selectedIdArr[currentStep] = selectedIdArr[currentStep-1];
            }
            this.state.currentStep++;
            this.state.currentStep === this.db.steps.length ? this.renderResultPage() : this.update();
        });

        $(document).on('click', '.js-config-prev', (e) => {
            const {currentStep} = this.state;
            if(currentStep === 0) return;

            e.preventDefault();
            this.state.selectedIdArr[currentStep] = null;
            if(currentStep === this.db.steps.length) {
                this.elems.$list.removeClass('_hidden');
                this.elems.$socialList.addClass('_hidden');
            }
            this.state.currentStep--;
            this.update();
        });
    }

    setActive(id) {
        const {currentStep, selectedIdArr} = this.state;
        const {$mainImg, $list, $nextBtn} = this.elems;

        const imgUrl = this.getImgUrlById(id);

        $mainImg.attr('src', imgUrl);
        $nextBtn.removeClass('_hidden');
        this.removeActive();

        const prevId = selectedIdArr[currentStep-1];
        $list
            .find(`.js-material-btn[data-img-id="${id ? id : prevId}"]`)
            .addClass('_active')
            .find('.js-choose-btn')
            .text('Выбрано');

        selectedIdArr[currentStep] = id ? id : prevId;
    }

    removeActive(isCancel) {
        const {$list, $nextBtn} = this.elems;
        const {currentStep, selectedIdArr} = this.state;

        $list
            .find(`.js-material-btn[data-img-id="${selectedIdArr[currentStep]}"]`)
            .removeClass('_active')
            .find('.js-choose-btn')
            .text('Выбрать');

        selectedIdArr[currentStep] = null;

        if(isCancel) this.setBackStepImg();
        if(isCancel && currentStep === 0) $nextBtn.addClass('_hidden');
    }

    setBackStepImg() {
        const {currentStep, selectedIdArr} = this.state;
        const {$mainImg} = this.elems;
        let url;

        if(currentStep === 0) {
            url = this.db.empty;
        } else {
            const prevId = selectedIdArr[currentStep-1];
            // const imgId = this.getImgId(selectedIdArr[currentStep-1], currentStep-1)
            url = this.getImgUrlById(prevId);
        }

        $mainImg.attr('src', url);
    }

    // getImgId(elemId, step) {
    //     const {currentStep, selectedIdArr} = this.state;
    //     let result;
    //
    //     if(step === 0) {
    //         result = this.db.steps[step].items
    //             .find(item => elemId === item.id)
    //             .imgId;
    //     } else {
    //         result = this.db.steps[step].items
    //             .find(item => elemId === item.id)
    //             .imgIdMap[selectedIdArr[currentStep - 1]];
    //     }
    //
    //     return result
    // }

    getItemIdByImgId(id) {
        const {currentStep} = this.state;

        const result = this.db.steps[currentStep].items.find(item => {
            if(item.imgId) {
                return item.imgId === id ? true : false;
            } else if(item.imgIdMap) {
                return Object.values(item.imgIdMap).find(value => id === value);
            }
        });
        return result.id

    }

    getImgUrlById(imgId) {
        return db.images.find(image => image.id === imgId).url;
    }
    getShareImgUrlById(imgId) {
        return db.images.find(image => image.id === imgId).share;
    }
    getVkIDById(imgId) {
        return db.images.find(image => image.id === imgId).vk;
    }

    parseHash(){
        let hash = window.location.hash.substring(1).split('&');
        let self = this;
        hash.forEach(function(e){
            let set = e.split('=');
            switch (set[0]){
                case 'user_id': self.user.id = set[1]; break;
                case 'email': self.user.email = set[1]; break;
                case 'state':
                    self.state = JSON.parse(decodeURI(set[1]));
                    let id = self.state.selectedIdArr[self.state.currentStep-1];
                    self.setActive(id);
                    self.renderResultPage();
                    break;
            }
        });
    }
}

const $root = $('.js-configurator');
if($root.length) {
    const myConfigurator = new Configurator($root);
    window.state = myConfigurator.state;
}


// const base = '/assets/img/configurator/';


function timer() {
    const $timer = $('.js-timer');
    if(!$timer.length) return

    let digits = {

    };
    $timer.find('.js-timer-field').each(function() {
        const fieldName = $(this).data('field');
        const fieldDigits = $(this).find('.js-timer-digit');
        digits[fieldName] = [
            $(this).children('[data-first]'),
            $(this).children('[data-second]'),
        ]
    });

    const finishDate = new Date(2021, 2, 31, 24, 0);

    update();

    function update() {
        let remainTime = finishDate - Date.now();
        if(remainTime <= 0) return

        const days = remainTime / (1000 * 60 * 60 * 24);
        const daysStr = Math.floor(days).toString();
        const normalizeDaysStr = normalize(daysStr);

        const hours = (days - Math.floor(days)) * 24;
        const hoursStr = Math.floor(hours).toString();
        const normalizeHoursStr = normalize(hoursStr);

        const minutes = (hours - Math.floor(hours)) * 60;
        const minutesStr = Math.floor(minutes).toString();
        const normalizeMinutesStr = normalize(minutesStr);

        const secondsStr = Math.floor((minutes - Math.floor(minutes)) * 60).toString();
        const normalizeSecondsStr = normalize(secondsStr);

        digits.days[0].text(normalizeDaysStr[0]);
        digits.days[1].text(normalizeDaysStr[1]);

        digits.hours[0].text(normalizeHoursStr[0]);
        digits.hours[1].text(normalizeHoursStr[1]);

        digits.minutes[0].text(normalizeMinutesStr[0]);
        digits.minutes[1].text( normalizeMinutesStr[1]);

        digits.seconds[0].text(normalizeSecondsStr[0]);
        digits.seconds[1].text(normalizeSecondsStr[1]);
        setTimeout(update, 1000);
    }

    function normalize(str) {
        return str.length === 1 ? '0' + str : str;
    }



}

const playerArr = [];

     // 2. This code loads the IFrame Player API code asynchronously.
     var tag = document.createElement('script');

     tag.src = "https://www.youtube.com/iframe_api";
     var firstScriptTag = document.getElementsByTagName('script')[0];
     firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

     // 3. This function creates an <iframe> (and YouTube player)
     //    after the API code downloads.
     function onYouTubeIframeAPIReady() {
         $('.js-youtube-video').each(function() {
            const player = new YT.Player(this, {
              videoId: this.dataset.videoId,
              events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange,

              }
            });
            playerArr.push(player);
         });
     }

     // 4. The API will call this function when the video player is ready.
     function onPlayerReady(event) {
        // event.target.playVideo();
     }

     // 5. The API calls this function when the player's state changes.
     //    The function indicates that when playing a video (state=1),
     //    the player should play for six seconds and then stop.
    //  var done = false;
     function onPlayerStateChange(event) {
        if(event.data === 1) {
            $('body').addClass('_tab-video-playing');
        } else {
            $('body').removeClass('_tab-video-playing');
        }

    //    if (event.data == YT.PlayerState.PLAYING && !done) {
    //      setTimeout(stopVideo, 6000);
    //      done = true;
    //    }
     }
     function stopVideo() {
       playerArr.forEach(player => player.pauseVideo());
     }



